/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Exception on the IoE itself. Only possible for IoEs without object findings; null if there is none.
 * @export
 * @interface GetAllIoes200ResponseIoeInnerException
 */
export interface GetAllIoes200ResponseIoeInnerException {
    /**
     * Reason category of the exception.
     */
    reason?: string | null;
    /**
     * Free-text comment explaining the exception.
     */
    comment?: string | null;
    /**
     * UUID of the user who created the exception.
     */
    userUuid?: string | null;
    /**
     * Time the exception was created.
     */
    at?: string | null;
    /**
     * Time the exception expires. Null if it does not expire.
     */
    until?: string | null;
}

/**
 * Check if a given object implements the GetAllIoes200ResponseIoeInnerException interface.
 */
export function instanceOfGetAllIoes200ResponseIoeInnerException(value: object): value is GetAllIoes200ResponseIoeInnerException {
    return true;
}

export function GetAllIoes200ResponseIoeInnerExceptionFromJSON(json: any): GetAllIoes200ResponseIoeInnerException {
    return GetAllIoes200ResponseIoeInnerExceptionFromJSONTyped(json, false);
}

export function GetAllIoes200ResponseIoeInnerExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllIoes200ResponseIoeInnerException {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] === undefined ? undefined : json['reason'] === null ? null : json['reason'],
        'comment': json['comment'] === undefined ? undefined : json['comment'] === null ? null : json['comment'],
        'userUuid': json['userUuid'] === undefined ? undefined : json['userUuid'] === null ? null : json['userUuid'],
        'at': json['at'] === undefined ? undefined : json['at'] === null ? null : json['at'],
        'until': json['until'] === undefined ? undefined : json['until'] === null ? null : json['until'],
    };
}

export function GetAllIoes200ResponseIoeInnerExceptionToJSON(json: any): GetAllIoes200ResponseIoeInnerException {
    return GetAllIoes200ResponseIoeInnerExceptionToJSONTyped(json, false);
}

export function GetAllIoes200ResponseIoeInnerExceptionToJSONTyped(value?: GetAllIoes200ResponseIoeInnerException | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'comment': value['comment'],
        'userUuid': value['userUuid'],
        'at': value['at'],
        'until': value['until'],
    };
}

